<template>
  <div id="app">
    <PageLoader />
    <AppHeader />
    <router-view :key="$route.fullPath" />
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import PageLoader from "./components/PageLoader.vue";

import { mapGetters } from "vuex";
import axios from "axios";
const apiResourceUrl = process.env.VUE_APP_APIURL;

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    PageLoader,
  },
  async created() {
    var rootObject = this;
    await axios
      .get(apiResourceUrl + "/userinfo")
      .then(function(response) {
        rootObject.$store.dispatch("user", response.data);
        console.log("Authorized & Logged In");
      })
      .catch(function(error) {
        let alertmessage = "";
        for (var prop in error.response.data) {
          alertmessage += " " + error.response.data[prop];
        }
        console.log(alertmessage);
        localStorage.removeItem("token");
        rootObject.$store.dispatch("user", null);
      });

    await axios.get(apiResourceUrl + "/websitesettings").then((response) => {
      //console.log(response.data.settings)
      rootObject.$store.dispatch("settings", response.data.settings);
    });

    await axios.get(apiResourceUrl + "/projects").then((response) => {
      //console.log(response.data.settings)
      rootObject.$store.dispatch("projectData", response.data.projects);
      rootObject.$store.dispatch(
        "homeHighlightedProjectData",
        response.data.projects.slice(0, 5)
      );
      rootObject.$store.dispatch(
        "homeAreaBottomProjectData",
        response.data.projects.slice(5, 9)
      );
    });

    this.$store.dispatch("isloaded", true);
  },
  computed: {
    ...mapGetters({
      user: "user",
      myAppName: "getAppName",
      //settings : 'settings'
    }),
  },
};
</script>

<style></style>
